// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ReleaseGoNoGoThreshold,
  ReleaseGoNoGoThresholdFromJSON,
  ReleaseGoNoGoThresholdToJSON,
} from "./";

/**
 *
 * @export
 * @interface ReleasePayload
 */
export interface ReleasePayload {
  /**
   *
   * @type {string}
   * @memberof ReleasePayload
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ReleasePayload
   */
  description?: string;
  /**
   * Optional glob pattern matched against build versions to auto-group builds into this release (TCV-6723). Leading `v` ignored; `*` matches any suffix (e.g. `2.14.*`). Send an empty string to clear.
   * @type {string}
   * @memberof ReleasePayload
   */
  versionPattern?: string;
  /**
   *
   * @type {string}
   * @memberof ReleasePayload
   */
  status: ReleasePayloadStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ReleasePayload
   */
  targetDate?: string;
  /**
   *
   * @type {string}
   * @memberof ReleasePayload
   */
  releaseDate?: string;
  /**
   *
   * @type {ReleaseGoNoGoThreshold}
   * @memberof ReleasePayload
   */
  goNoGoThreshold?: ReleaseGoNoGoThreshold;
  /**
   *
   * @type {boolean}
   * @memberof ReleasePayload
   */
  isPublic?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReleasePayload
   */
  project: number;
  /**
   * Array of test plan IDs to associate with this release
   * @type {Array<number>}
   * @memberof ReleasePayload
   */
  testPlans?: Array<number>;
  /**
   * Array of requirement IDs to associate with this release
   * @type {Array<number>}
   * @memberof ReleasePayload
   */
  requirements?: Array<number>;
}

export function ReleasePayloadFromJSON(json: any): ReleasePayload {
  return {
    name: json["name"],
    description: !exists(json, "description") ? undefined : json["description"],
    versionPattern: !exists(json, "version_pattern")
      ? undefined
      : json["version_pattern"],
    status: json["status"],
    targetDate: !exists(json, "target_date") ? undefined : json["target_date"],
    releaseDate: !exists(json, "release_date")
      ? undefined
      : json["release_date"],
    goNoGoThreshold: !exists(json, "go_no_go_threshold")
      ? undefined
      : ReleaseGoNoGoThresholdFromJSON(json["go_no_go_threshold"]),
    isPublic: !exists(json, "is_public") ? undefined : json["is_public"],
    project: json["project"],
    testPlans: !exists(json, "test_plans") ? undefined : json["test_plans"],
    requirements: !exists(json, "requirements")
      ? undefined
      : json["requirements"],
  };
}

export function ReleasePayloadToJSON(value?: ReleasePayload): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    name: value.name,
    description: value.description,
    version_pattern: value.versionPattern,
    status: value.status,
    target_date: value.targetDate,
    release_date: value.releaseDate,
    go_no_go_threshold: ReleaseGoNoGoThresholdToJSON(value.goNoGoThreshold),
    is_public: value.isPublic,
    project: value.project,
    test_plans: value.testPlans,
    requirements: value.requirements,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ReleasePayloadStatusEnum {
  Planned = "planned",
  InProgress = "in_progress",
  Ready = "ready",
  Shipped = "shipped",
  Blocked = "blocked",
}
